<template>
    <div class="sidebar">
        <div class="sidebar-inner">

            <template v-if="type == 'filters'">
                <h3>Search filters</h3>
                <div class="filters form">
                    <template v-if="this.$route.name != 'home'">
                        <span>Filters are only available on the main page. <router-link class="link" :to="{ name: 'home' }">Click here to go back</router-link></span>
                    </template>
                    <template v-else>
                        <div class="form-group">
                            <label for="filter-status">Status</label>
                            <select id="filter-status" v-model="status" class="form-control">
                                <option value="-1" selected>All</option>
                                <option value="0">{{ 0|formatStatus }}</option>
                                <option value="1">{{ 1|formatStatus }}</option>
                                <option value="2">{{ 2|formatStatus }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="filter-search">Search</label>
                            <input type="text" id="filter-search" @keyup="updateSearchInput" class="form-control" title="Login/site/company name, id_site, id_customer"/>
                        </div>
                        <div class="form-group">
                            <label for="filter-date">Date</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">From</span>
                                </div>
                                <input v-model="dateMin" id="filter-date-min" class="form-control" type="text" placeholder="YYYY-MM-DD"/>
                            </div>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">To</span>
                                </div>
                                <input v-model="dateMax" id="filter-date-max" class="form-control" type="text" placeholder="YYYY-MM-DD"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="filter-log-events" title="None selected = all">Login events</label>
                            <div v-for="e in logEvents" :key="e.id_event" class="log-event-filter col-auto custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" @change="toggleLogEvent(e.id_event)" :id="'filter-log-event-' + e.id_event">
                                <label :for="'filter-log-event-' + e.id_event" class="custom-control-label">{{ e.event_text }}</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="">Login attempts</label>
                            <div class="custom-control custom-checkbox col-auto">
                                <input type="checkbox" class="custom-control-input" id="successful-login-attempts" v-model="successfulAttempts"/>
                                <label for="successful-login-attempts" class="custom-control-label">Has successful login attempts</label>
                            </div>
                            <div class="custom-control custom-checkbox col-auto">
                                <input type="checkbox" class="custom-control-input" id="failed-login-attempts" v-model="failedAttempts"/>
                                <label for="failed-login-attempts" class="custom-control-label">Has failed login attempts</label>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <template v-else-if="type == 'add-credentials'">
                <h3>Add credentials</h3>
            </template>
        </div>
    </div>
</template>

<script>
import { debounce } from 'debounce'

export default {
    name: 'Sidebar',
    props: {
        type: {
            type: String,
            default: 'filters'
        }
    },
    methods: {
        toggleLogEvent(id) {
            // TODO: Fix removing

            if (this.logEventsFilter.indexOf(id) === -1) {
                this.logEventsFilter.push(id)
            } else {
                for (let i = 0; i < this.logEventsFilter.length; i++) {
                    if (this.logEventsFilter[i] == id) {
                        this.logEventsFilter.splice(i, 1)
                        break
                    }
                }
            }
        },
        updateSearchInput: debounce(function(e) {
            this.search = e.target.value
        }, 200)
    },
    created: function() {
        this.$store.dispatch('fetchLogEvents')
    },
    watch: {
        status: function() { this.$store.dispatch('fetchLogins') },
        logEventsFilter: function() { this.$store.dispatch('fetchLogins') },
        dateMin: function(newVal, oldVal) {
            let ol = 0
            if (oldVal && oldVal.length) {
                ol = oldVal.length
            }
            let adding = newVal.length > ol

            if (adding) {
                if (newVal.length == 4) {
                    this.dateMin += "-"
                } else if (newVal.length == 7) {
                    this.dateMin += "-"
                }
            } else {
                if (newVal.length == 5 || newVal.length == 8) {
                    this.dateMin = this.dateMin.substring(0, this.dateMin.length - 1)
                }
            }
            this.$store.dispatch('fetchLogins')
        },
        dateMax: function(newVal, oldVal) {
            let ol = 0
            if (oldVal && oldVal.length) {
                ol = oldVal.length
            }
            let adding = newVal.length > ol

            if (adding) {
                if (newVal.length == 4) {
                    this.dateMax += "-"
                } else if (newVal.length == 7) {
                    this.dateMax += "-"
                }
            } else {
                if (newVal.length == 5 || newVal.length == 8) {
                    this.dateMax = this.dateMax.substring(0, this.dateMax.length - 1)
                }
            }
            this.$store.dispatch('fetchLogins')
        },
        search: function() { this.$store.dispatch('fetchLogins') },
        successfulAttempts: function() { this.$store.dispatch('fetchLogins') },
        failedAttempts: function() { this.$store.dispatch('fetchLogins') }
    },
    computed: {
        logEvents: function() {
            return this.$store.state.logEvents
        },
        search: {
            get() {
                return this.$store.state.filters.search
            },
            set(value) {
                this.$store.commit('updateSearch', value)
            }
        },
        status: {
            get() {
                return this.$store.state.filters.status
            },
            set(value) {
                this.$store.commit('updateStatus', value)
            }
        },
        logEventsFilter: {
            get() {
                return this.$store.state.filters.logEvents
            },
            set(value) {
                this.$store.commit('updateLogEventsFilter', value)
            }
        },
        dateMin: {
            get() {
                return this.$store.state.filters.date.min
            },
            set(value) {
                this.$store.commit('updateDateMin', value)
            }
        },
        dateMax: {
            get() {
                return this.$store.state.filters.date.max
            },
            set(value) {
                this.$store.commit('updateDateMax', value)
            }
        },
        successfulAttempts: {
            get() {
                return this.$store.state.filters.successfulAttempts
            },
            set(value) {
                this.$store.commit('updateSuccessfulAttempts', value)
            }
        },
        failedAttempts: {
            get() {
                return this.$store.state.filters.failedAttempts
            },
            set(value) {
                this.$store.commit('updateFailedAttempts', value)
            }
        }
    }
}
</script>

<style scoped lang="sass">
@import '@/styles/default.sass'

.sidebar
    position: relative
    height: 100%

    .sidebar-inner
        padding-top: 15px
        height: 100%
        overflow-y: auto
        padding-right: 5px

        .input-group
            margin-bottom: 4px

        .filters
            flex-grow: 1

            .log-event-filter
                margin-bottom: 6px

        .link
            color: $gray
            cursor: pointer
            text-decoration: none

            &:hover
                color: $black

        .dl-range
            input[type="range"]
                padding: 0

            td.label
                text-align: right
                min-width: 32px

        .sidebar-help
            font-size: $font-size-medium
            a
                color: $gray
                text-decoration: none

                &:hover
                    color: $black

.sidebar-dep
    position: absolute
    left: 0
    top: 0
    width: $sidebar-width
    height: 100%
    background: $sidebar-background
    box-shadow: -4px 0px 9px rgba(0, 0, 0, 0.5)
    z-index: 1000

    .sidebar-inner
        padding: 25px
        height: 100%
        display: flex
        flex-direction: column
        overflow: auto

        h1, h2, h3
            margin: 0 0 8px

        h2
            font-size: $font-size-big

</style>
